import { PRODUCTQTYMINUS, PRODUCTQTYPLUS } from "./actionTypes";

export const productQtyPlus = (id, value) => {
  return {
    type: PRODUCTQTYPLUS,
    id,
    value,
  };
};

export const productQtyMinus = (id, value) => {
  return {
    type: PRODUCTQTYMINUS,
    id,
    value,
  };
};
